import {
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    Typography,
  } from "@mui/material";
  import React, { useState } from "react";
  import MoreVertIcon from "@mui/icons-material/MoreVert";
  import DeleteIcon from "@mui/icons-material/Delete";
  import ViewIcon from "@mui/icons-material/Visibility";
  import EditIcon from "@mui/icons-material/Edit";
  import CheckCircleIcon from "@mui/icons-material/CheckCircle";
  import BlockIcon from "@mui/icons-material/Block";
  import ReorderIcon from "@mui/icons-material/Reorder";
  
  interface IGenericAction {
    label: string;
    icon: GENERIC_ICON_NAME;
    onClick: (row: any) => void;
  }
  
  interface IGenericActionPickerProps {
    row: any;
    actions: IGenericAction[];
  }
  
  export enum GENERIC_ICON_NAME {
    EDIT = "edit",
    DELETE = "delete",
    VIEW = "view",
    BLOCK = "block",
    CHECK_CIRCLE = "check_circle",
    REORDER = "reorder",
  }
  
  const GenericActionPicker: React.FC<IGenericActionPickerProps> = ({
    row,
    actions,
  }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
  
    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleMenuClose = () => {
      setAnchorEl(null);
    };
  
    const getIcon = (iconName: GENERIC_ICON_NAME) => {
      switch (iconName) {
        case GENERIC_ICON_NAME.EDIT:
          return <EditIcon fontSize="small" />;
        case GENERIC_ICON_NAME.DELETE:
          return <DeleteIcon fontSize="small" />;
        case GENERIC_ICON_NAME.VIEW:
          return <ViewIcon fontSize="small" />;
        case GENERIC_ICON_NAME.BLOCK:
          return <BlockIcon fontSize="small" />;
        case GENERIC_ICON_NAME.CHECK_CIRCLE:
          return <CheckCircleIcon fontSize="small" />;
        case GENERIC_ICON_NAME.REORDER:
          return <ReorderIcon fontSize="small" />;
        default:
          return null;
      }
    };
  
    return (
      <>
        <IconButton
          onClick={handleMenuOpen}
          size="small"
          sx={{ padding: 0.5 }}
          title="Options"
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          MenuListProps={{ dense: true }}
        >
          {actions.map((action, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                action.onClick(row);
                handleMenuClose();
              }}
              sx={{ minHeight: "32px", paddingY: "4px", paddingX: "8px" }}
            >
              <ListItemIcon sx={{ minWidth: "32px" }}>
                {getIcon(action.icon)}
              </ListItemIcon>
              <Typography variant="body2">{action.label}</Typography>
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  };
  
  export default GenericActionPicker;
  